export enum AccountSettingsTab {
  PROFILE = "Profile",
  SECURITY = "Security",
  NOTIFICATIONS = "Notifications",
  PULSE = "Pulse",
  WORKING_HOURS = "Working Hours",
  AGENT_SETTINGS = "Agent Settings"
}
